export const footerLinks = [
  {
    title: "Company",
    links: [
      { name: "About" },
      { name: "Features" },
      { name: "Works" },
      { name: "Career" },
    ],
  },
  {
    title: "Help",
    links: [
      { name: "Customer Support" },
      { name: "Delivery Details" },
      { name: "Terms & Conditions" },
      { name: "Privacy Policy" },
    ],
  },
  {
    title: "Resources",
    links: [
      { name: "Free eBooks" },
      { name: "Development Tutorial" },
      { name: "How to - Blog" },
      { name: "Youtube Playlist" },
    ],
  },
  {
    title: "Links",
    links: [
      { name: "Free eBooks" },
      { name: "Development Tutorial" },
      { name: "How to - Blog" },
      { name: "Youtube Playlist" },
    ],
  },
];
